import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

interface AuthGuardProps {
  children: React.ReactNode; // Make children a required prop
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login", { replace: true }); // Redirect to login if not authenticated
    }
  }, [isLoggedIn, navigate]);

  if (!isLoggedIn) return null; // Prevent rendering before redirecting

  return children; // Render the provided children
};

export default AuthGuard;
